// extracted by mini-css-extract-plugin
module.exports = {"update":"ShareBlock_update__c0p8a","links":"ShareBlock_links__AkU_d","link":"ShareBlock_link__O2pPI","tooltip":"ShareBlock_tooltip__GOstF","copied":"ShareBlock_copied__jieH6"};